import SearchMonth from "../Component/Search/SearchMonth";
import SearchRange from "../Component/Search/SearchRange";

import React, { useState, useEffect } from "react";
import Datagrid from "../Component/Datagrid/Datagrid_chart";
import DownloadSelectedZipButton from "../Component/Datagrid/DownloadSelectedZipButton";
import MultilineForm from "../Component/Search/MuiltilineForm";
import TitleComponent from "../Component/Title/TitleComponent";
import Box from "@mui/material/Box";
import Tab from "@mui/material/Tab";
import TabContext from "@mui/lab/TabContext";
import TabList from "@mui/lab/TabList";
import TabPanel from "@mui/lab/TabPanel";
import { styled } from "@mui/material/styles";
import DialogComponent from "../Component/Popup/DialogComponent";
import IndvRefund from "../Component/business/refund/IndvRefund";
import JSONasXlsx from "../Modules/JSON-to-Excel/JSONasXlsx";
import { useRecoilState } from "recoil";
import { modalAtom } from "../states/Atoms/StatusAtoms";
import { vehiclesState } from "../states/Atoms/vehiclesAtom";
import { FormControl, MenuItem, Select } from "@mui/material";

const ChartPage = () => {
  const [type, setType] = useState("A");
  const [month, setMonth] = useState("");
  const [year, setYear] = useState("");
  const [value, setValue] = useState("1");
  const [vinNumber, setVinNumber] = useState("");
  const [pageSize, setPageSize] = useState(50);
  const [vehiclesData, setVehiclesData] = useRecoilState(vehiclesState);
  const [selectedRows, setSelectedRows] = useState([]);

  // 탭 변경 시 리스트 초기화
  useEffect(() => {
    setVehiclesData([]);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [value]);

  useEffect(() => {}, [vehiclesData]);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  const [open, setOpen] = useRecoilState(modalAtom);
  const handleClose = () => {
    setOpen(false);
  };
  const handleOpen = (vin) => {
    setOpen(true);
  };

  return (
    <>
      <TitleComponent Title="기간/일괄 조회" type={2} />
      <div className="container">
        <Box
          sx={{
            display: "flex",
            alignItems: "stretch",
            flex: 1,
            background: "#ffffff",
          }}
        >
          <Box
            sx={{
              flex: 1,
              mt: 4,
              mb: 2,
              p: 1,
              border: "1px solid #ccc",
              borderRadius: "4px",
            }}
          >
            <TabContext value={value}>
              <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
                <TabList
                  onChange={handleChange}
                  aria-label="lab API tabs example"
                >
                  <StyledTab label="월별조회" value="1" />
                  <StyledTab label="일괄조회" value="2" />
                  <StyledTab label="기간조회" value="3" />
                </TabList>
              </Box>
              <TabPanel value="1" sx={{ p: 2 }}>
                <SearchMonth
                  // SetVehicleData={SetVehiclesData}
                  SetVehicleData={setVehiclesData}
                  setYear={setYear}
                  year={year}
                  month={month}
                  setMonth={setMonth}
                  setType={setType}
                  type={type}
                />
              </TabPanel>
              <TabPanel value="2" sx={{ p: 2 }}>
                <MultilineForm SetVehicleData={setVehiclesData} />
              </TabPanel>
              <TabPanel value="3" sx={{ p: 2 }}>
                <SearchRange setType={setType} type={type} />
              </TabPanel>
            </TabContext>
          </Box>
        </Box>
        <Box sx={{ display: "flex", flexDirection: "column", pb: 10, gap: 1 }}>
          <Box
            display="flex"
            justifyContent="space-between"
            alignItems="center"
          >
            <Box
              color={"#aaa"}
              pl={1}
              fontSize={14}
              display="flex"
              flexDirection="column"
              gap={1}
            >
              총 {vehiclesData?.length}개의 조회 결과
              <DownloadSelectedZipButton selectedRows={selectedRows} />
            </Box>
            <Box
              color={"#aaa"}
              fontSize={13}
              textAlign="right"
              lineHeight={1.6}
              sx={{ ml: "auto", mr: 2 }}
            >
              해당 금액은 수리일자 기준 아래와 같이 산출된 내역입니다.
              <br />
              1) 수입통관일(수리일자): ~26년 6월 30일 / 개별소비세율 3.5% 적용
              <br />
              2) 수입통관일(수리일자): 26년 7월 1일 ~ / 개별소비세율 5% 적용
            </Box>
            <Box display="flex" gap="5px" alignItems="center">
              <FormControl size="small">
                <Select
                  value={pageSize}
                  onChange={(e) => setPageSize(e.target.value)}
                >
                  <MenuItem value={10}>10개씩 보기</MenuItem>
                  <MenuItem value={50}>50개씩 보기</MenuItem>
                  <MenuItem value={100}>100개씩 보기</MenuItem>
                </Select>
              </FormControl>
              <JSONasXlsx vehicleData={vehiclesData} />
            </Box>
          </Box>
          <Datagrid
            pageSize={pageSize}
            vehicleData={vehiclesData}
            handleOpen={handleOpen}
            setVinNumber={setVinNumber}
            setSelectedRows={setSelectedRows}
          />
        </Box>
      </div>

      <DialogComponent open={open} handleClose={handleClose}>
        <IndvRefund vin={vinNumber} />
      </DialogComponent>
    </>
  );
};

const StyledTab = styled((props) => <Tab disableRipple {...props} />)(
  ({ theme }) => ({
    textTransform: "none",
    fontWeight: theme.typography.fontWeightRegular,
    fontSize: theme.typography.pxToRem(15),
    marginRight: theme.spacing(1),
    color: "#aaa",
    "&.Mui-selected": {
      color: "#000",
    },
    "&.Mui-focusVisible": {
      backgroundColor: "rgba(100, 95, 228, 0.32)",
    },
  })
);
export default ChartPage;
